// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__3t93w","radioRow":"SimpleQuestionBuilderModal_radioRow__2NyEo"};